<svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    >
    <g opacity="0.5">
        <path
        d="M0 3C0 1.34315 1.34315 0 3 0H21C22.6569 0 24 1.34315 24 3V21C24 22.6569 22.6569 24 21 24H3C1.34315 24 0 22.6569 0 21V3Z"
        fill="white"
        />
        <path
        d="M9.08286 15.8212L5.92203 12.6604C5.76486 12.5086 5.55436 12.4246 5.33586 12.4265C5.11736 12.4284 4.90835 12.516 4.75384 12.6705C4.59934 12.825 4.5117 13.034 4.5098 13.2525C4.5079 13.471 4.59189 13.6815 4.74369 13.8387L8.49369 17.5887C8.64997 17.7449 8.86189 17.8327 9.08286 17.8327C9.30383 17.8327 9.51575 17.7449 9.67203 17.5887L18.8387 8.42203C18.9905 8.26486 19.0745 8.05436 19.0726 7.83586C19.0707 7.61736 18.983 7.40835 18.8285 7.25384C18.674 7.09934 18.465 7.0117 18.2465 7.0098C18.028 7.0079 17.8175 7.09189 17.6604 7.24369L9.08286 15.8212Z"
        fill="url(#paint0_linear_3580_15632)"
        />
        <path
        d="M3 1H21V-1H3V1ZM23 3V21H25V3H23ZM21 23H3V25H21V23ZM1 21V3H-1V21H1ZM3 23C1.89543 23 1 22.1046 1 21H-1C-1 23.2091 0.790861 25 3 25V23ZM23 21C23 22.1046 22.1046 23 21 23V25C23.2091 25 25 23.2091 25 21H23ZM21 1C22.1046 1 23 1.89543 23 3H25C25 0.790861 23.2091 -1 21 -1V1ZM3 -1C0.790861 -1 -1 0.790861 -1 3H1C1 1.89543 1.89543 1 3 1V-1Z"
        fill="#DDDDDD"
        />
    </g>
    <defs>
        <linearGradient
        id="paint0_linear_3580_15632"
        x1="19.0726"
        y1="7.00977"
        x2="3.10357"
        y2="15.0343"
        gradientUnits="userSpaceOnUse"
        >
        <stop stop-color="#FF2E00" />
        <stop offset="1" stop-color="#FF6B00" />
        </linearGradient>
    </defs>
</svg>